/** @format */

//TODO: Remove eslint-disable and fix the error properly
/* eslint-disable react/no-string-refs */

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import withStyles from '@material-ui/core/styles/withStyles';
import i18n from '../core/i18n';
import AdminNavbar from 'components/Navbars/AdminNavbarExt.jsx';
import Footer from 'components/Footer/Footer.jsx';
import Sidebar from 'components/Sidebar/SidebarExt';
import image from 'assets/img/sidebar-2.jpg';
import { notificationConstants } from '../modules/notifications/notifications';
import SnackBarMessage from '../helpers/SnackBarMessage';
import Loader from '../components/Loaders/Loader.js';
import { menuActions } from '../modules/menu/action';
import { UserRoleHelper } from '../helpers/UserRoleHelper';
import Notifier from '../core/Notifier';
import { DynamicElements } from '../core/DynamicElements';
import { ItemLoaders } from '../core/loaders/ItemLoaders';
import { RefreshToken } from '../core/RefreshToken';
import TimerEvent from '../core/timers/Event/TimerEvent';
import { TimerManagerSubscribeEventEnum } from '../core/timers/Enum/TimerManagerSubscribeEventEnum';
import { TimerManager } from '../core/timers/TimerManager';
import OrangeLogo from '../assets/themes/OPL/img/OrangeLogo.png';
import oplAppStyle from '../assets/themes/OPL/jss/App/OplAppStyle';
import { store } from '../core/store';
import { scrollPositionReducer } from '../modules/scrollPositionReducer/scrollPositionReducer';
import { StoreHelper } from '../helpers/StoreHelper';
import I18n from '../components/Translate/I18n';

const axios = require('axios');

let axiosInterRequest = null;
let axiosInterResponse = null;

let ps;

class Admin extends React.Component {
    constructor(props) {
        super(props);
        store.injectReducer('scrollPositionReducer', scrollPositionReducer);
        StoreHelper.requiresStore(this, 'scrollPositionReducer');
        this.state = {
            brandText: null,
            loader: false,
            mobileOpen: false,
            miniActive: false,
            image: image,
            color: 'orange',
            bgColor: 'black',
            hasImage: true,
            fixedClasses: 'dropdown',

            snackBarStatus: false,
            snackBarMessage: '',
            snackBarVariant: 'success',
            componentBrandText: null,

            loaderVisible: false,
            menu: [],
            clientsList: null,
            clientObject: null,
            PlatformResellerList: null,
            currentPaginationPage: null,
            lastTariffId: null,
            searchBarName: null,
            topNavbarVisible: true,
        };
        this.namespace = 'TokenTtlCheck';
        this.identifier = 'TokenRefresh';
        this.timerInterval = 1000 * 5;
        this.searchCallback = null;
        this.refreshToken = new RefreshToken(new ItemLoaders(this.props.dispatch));
        this.timerManager = TimerManager.getInstance();
        this.timerEvent = TimerEvent.getInstance();
    }

    checkTimerExistsAndRunning = (callback) => {
        TimerEvent.getInstance().dispatch(
            TimerManagerSubscribeEventEnum.checkTimerExistsAndRunning,
            {
                detail: {
                    namespace: this.namespace,
                    identifier: this.identifier,
                },
            },
            callback
        );
    };

    createTimer = (e) => {
        if (e.success && e.result.exists === false) {
            TimerEvent.getInstance().dispatch(
                TimerManagerSubscribeEventEnum.createTimer,
                {
                    detail: {
                        namespace: this.namespace,
                        identifier: this.identifier,
                        timerOptions: {
                            identifier: this.identifier,
                            onTick: () => {
                                this.refreshToken.checkLastTick();
                            },
                            interval: this.timerInterval,
                        },
                    },
                },
                () => {
                    this.startTimer(e, true);
                }
            );
        } else {
            this.startTimer(e);
        }
    };

    startTimer = (e, overWriteExists = false) => {
        let tmpExists = e.result.exists;
        if (overWriteExists === true) {
            tmpExists = true;
        }
        if (e.success && tmpExists && !e.result.running) {
            TimerEvent.getInstance().dispatch(TimerManagerSubscribeEventEnum.startTimer, {
                detail: {
                    namespace: this.namespace,
                    identifier: this.identifier,
                },
            });
        }
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.status !== notificationConstants.CLEAR_NOTIFY) {
            if (this.state.snackBarStatus === false && !window.temporaryPasswordCustomSnackBarFix_DisableDefaultSnackbar) {
                switch (nextProps.status) {
                    case notificationConstants.SUBMIT_ERROR:
                        if (nextProps.error && nextProps.error.error) {
                            this.displayNotify(true, nextProps.error.error, 'error', '');
                        }
                        break;
                    case notificationConstants.ERROR:
                        if (nextProps.error && nextProps.error.message) {
                            let msg = '';
                            if (i18n.exists('error:api.' + nextProps.error.message.message)) {
                                msg = i18n.t('error:api.' + nextProps.error.message.message);
                            } else {
                                msg = nextProps.error.message.message;
                            }
                            this.displayNotify(true, msg, 'error', nextProps.error.message.title);
                        }
                        break;
                    case notificationConstants.ERROR_DELETE:
                        if (nextProps.error && nextProps.error.message) {
                            this.displayNotify(true, i18n.t('error:global.delete_error'), 'error', nextProps.error.message.title);
                        }
                        break;
                    case notificationConstants.CUSTOM_NOTIFY:
                        this.displayNotify(true, i18n.t(nextProps.message), nextProps.variant, '');
                        break;
                    default:
                        break;
                }
            }
        }
        if (nextProps.menu && this.state.menu.length === 0) {
            this.loadRemoteMenu(nextProps.menu);
        }
        return true;
    }

    loadRemoteMenu = (loadedMenu) => {
        const lmenu = loadedMenu['hydra:member'];
        const menu = lmenu.map((r) => {
            if (r.component === null) {
                return this.generateSubElement(r);
            } else {
                return this.generateActionElement(r);
            }
        });
        if (menu.length > 0) {
            this.setState({ menu: menu });
        }
    };

    generateSubElement = (elm) => {
        const views = elm.subMenus.map((s) => {
            return this.generateActionElement(s);
        });
        return {
            collapse: elm.collapse,
            name: elm.menuName,
            icon: DynamicElements[elm.icon],
            state: 'pageCollapse' + elm.icon,
            views: views,
        };
    };

    generateActionElement = (elm) => {
        return {
            path: elm.path,
            name: elm.menuName,
            mini: elm.initials,
            icon: DynamicElements[elm.icon],
            component: DynamicElements[elm.component],
            display: elm.visible,
            layout: elm.layout,
        };
    };

    searchBarSwitch = (type, callback) => {
        this.setState({ searchBarName: type }, () => {
            this.searchCallback = callback;
        });
    };

    searchBarCallback = (value) => {
        if (this.searchCallback) {
            this.searchCallback(value);
        }
    };

    displayNotify = (status, message, variant, title) => {
        const { dispatch } = this.props;
        this.setState(
            (prevProps) => ({
                snackBarStatus: status,
                snackBarMessage: message,
                snackBarVariant: variant,
            }),
            () => {
                dispatch({ type: notificationConstants.CLEAR_NOTIFY });
            }
        );
    };

    componentDidMount() {
        this.resizeFunction = this.resizeFunction.bind(this);
        this.checkTimerExistsAndRunning(this.createTimer);
        axiosInterRequest = axios.interceptors.request.use(
            (request) => {
                const refreshToken = request.url.indexOf('refresh_tokens');
                if (refreshToken === -1) {
                    this.refreshToken.checkToken(request.url);
                } else {
                    this.refreshToken.checkToken('checkIdleTime');
                }
                const { loader } = this.state;
                let method = request.method;
                if ((method === 'post' || method === 'put' || method === 'delete') && loader === false) {
                    this.loaderOnOff(refreshToken === -1);
                }
                return request;
            },
            (error) => {
                this.loaderOnOff(false);
                return Promise.reject(error);
            }
        );
        axiosInterResponse = axios.interceptors.response.use(
            (response) => {
                const { loader } = this.state;
                const method = response.config.method;
                if ((method === 'post' || method === 'put' || method === 'delete') && loader) {
                    this.loaderOnOff(false);
                }
                return response;
            },
            (error) => {
                this.loaderOnOff(false);
                return Promise.reject(error);
            }
        );

        if (process.env.REACT_APP_TYPE_MVNO !== 'true') {
            if (navigator.platform.indexOf('Win') > -1) {
                ps = new PerfectScrollbar(this.refs.mainPanel, {
                    suppressScrollX: true,
                    suppressScrollY: false,
                });
                document.body.style.overflow = 'hidden';
            }
        }
        window.addEventListener('resize', this.resizeFunction);
        const { dispatch } = this.props;
        dispatch(menuActions.getMenu());
        dispatch(UserRoleHelper.loadUserRole());
    }

    loaderOnOff = (value) => this.setState({ loader: value });

    componentWillUnmount() {
        TimerEvent.getInstance().dispatch(TimerManagerSubscribeEventEnum.removeTimersInNamespace, {
            detail: {
                namespace: this.namespace,
            },
        });
        if (axiosInterRequest) {
            axios.interceptors.request.eject(axiosInterRequest);
        }
        if (axiosInterResponse) {
            axios.interceptors.request.eject(axiosInterResponse);
        }
        if (process.env.REACT_APP_TYPE_MVNO !== 'true') {
            if (navigator.platform.indexOf('Win') > -1) {
                ps.destroy();
            }
        }
        window.removeEventListener('resize', this.resizeFunction);
    }

    componentDidUpdate(e) {
        if (e.history.location.pathname !== e.location.pathname) {
            this.refs.mainPanel.scrollTop = 0;
            if (this.state.mobileOpen) {
                this.setState({ mobileOpen: false });
            }
        }
    }

    closeSnackbarCallback = () => {
        this.setState({ snackBarStatus: false, snackBarMessage: '' });
    };

    handleSetObject = (stateName, object, callback = null) => {
        this.setState({ [stateName]: object }, callback);
    };

    handleGetObject = (stateName) => {
        if (this.state[stateName]) {
            return this.state[stateName];
        }
        return null;
    };

    handleGetObjectByKey = (stateName, key) => {
        let r = null;
        if (this.state[stateName]) {
            /**
             * @todo compare object timestamp
             */
            const stateObject = this.state[stateName];
            if (stateObject['hydra:member']) {
                stateObject['hydra:member'].map((f) => {
                    if (f['@id'] === key) {
                        r = f;
                    }
                });
            }
        }
        return r;
    };

    handleUpdateObjectByKey = (stateName, key, object) => {
        if (this.state[stateName]) {
            /**
             * @todo compare object timestamp
             */
        }
        return null;
    };

    handleImageClick = (image) => {
        this.setState({ image: image });
    };
    handleColorClick = (color) => {
        this.setState({ color: color });
    };
    handleBgColorClick = (bgColor) => {
        this.setState({ bgColor: bgColor });
    };
    handleFixedClick = () => {
        if (this.state.fixedClasses === 'dropdown') {
            this.setState({ fixedClasses: 'dropdown show' });
        } else {
            this.setState({ fixedClasses: 'dropdown' });
        }
    };
    handleDrawerToggle = () => {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    handleSetBrandText = (brandText) => {
        this.setState({ brandText: brandText });
    };

    showMainLoader = (show) => {
        this.setState({
            loader: show,
        });
    };

    getActiveRoute = (routes) => {
        const activeRoute = '';
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                const collapseActiveRoute = this.getActiveRoute(routes[i].views);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute.includes('general:menu.') ? collapseActiveRoute : `general:menu.${collapseActiveRoute}`;
                }
            } else {
                if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
                    return routes[i].name.includes('general:menu.') ? routes[i].name : `general:menu.${routes[i].name}`;
                }
            }
        }
        return activeRoute;
    };

    getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return this.getRoutes(prop.views);
            }
            if (prop.layout === process.env.REACT_APP_ROUTE_NAME) {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        render={({ match }) => (
                            <prop.component
                                match={match}
                                handleSetObject={this.handleSetObject}
                                handleGetObject={this.handleGetObject}
                                handleGetObjectByKey={this.handleGetObjectByKey}
                                handleUpdateObjectByKey={this.handleUpdateObjectByKey}
                                handleSetBrandText={this.handleSetBrandText}
                                searchBarSwitch={this.searchBarSwitch}
                                showMainLoader={this.showMainLoader}
                            />
                        )}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    sidebarMinimize() {
        this.setState({ miniActive: !this.state.miniActive });
    }

    resizeFunction() {
        if (window.innerWidth >= 960) {
            this.setState({ mobileOpen: false });
        }
    }

    onScrollHandler = (event) => {
        if (event.currentTarget.scrollTop >= 1 && this.state.topNavbarVisible === true) {
            this.setState((prevState) => ({
                ...prevState,
                topNavbarVisible: false,
            }));
        }

        if (event.currentTarget.scrollTop < 1 && this.state.topNavbarVisible === false) {
            this.setState((prevState) => ({
                ...prevState,
                topNavbarVisible: true,
            }));
        }
    };


    render() {
        const { classes, ...rest } = this.props;
        const { brandText, loader } = this.state;
        const mainPanel =
            classes.mainPanel +
            ' ' +
            cx({
                [classes.mainPanelSidebarMini]: this.state.miniActive,
                [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
            });

        const titleName = this.getActiveRoute(this.state.menu);
        return (
            <div>
                <span style={{ display: 'none' }}>
                    <I18n trans="error:global.delete_error" />
                </span>
                <input type={'password'} readOnly={true} autoComplete={'password'} style={{ display: 'none' }} />
                <input type={'password'} readOnly={true} autoComplete={'new-password'} style={{ display: 'none' }} />
                <input type={'username'} readOnly={true} autoComplete={'username'} style={{ display: 'none' }} />
                <Loader fadeTime={5000} visible={this.state.loaderVisible} />
                <div className={classes.wrapper}>
                    <Sidebar
                        routes={this.state.menu}
                        logoText={''}
                        logo={OrangeLogo}
                        handleDrawerToggle={this.handleDrawerToggle}
                        open={this.state.mobileOpen}
                        color={this.state.color}
                        bgColor={this.state.bgColor}
                        miniActive={this.state.miniActive}
                        sidebarMinimize={this.sidebarMinimize.bind(this)}
                        {...rest}
                    />
                    <div className={mainPanel} ref="mainPanel" onScroll={this.onScrollHandler}>
                        <AdminNavbar
                            searchBox={this.state.searchBarName}
                            searchBarCallback={this.searchBarCallback}
                            brandText={titleName === '' ? brandText : titleName}
                            handleDrawerToggle={this.handleDrawerToggle}
                            scrollPosition={this.state.topNavbarVisible}
                            {...rest}
                        />
                        <div className={classes.content}>
                            <div className={classes.container}>
                                <Switch>{this.getRoutes(this.state.menu)}</Switch>
                            </div>
                        </div>
                        <Footer white />
                        <Notifier />
                        <SnackBarMessage
                            closeCallback={this.closeSnackbarCallback}
                            open={this.state.snackBarStatus}
                            text={this.state.snackBarMessage}
                            variant={this.state.snackBarVariant}
                        />
                    </div>
                </div>
                <Loader visible={loader} />
            </div>
        );
    }
}

Admin.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    const { notify, menuReducers, scrollPositionReducer } = state;
    let menu = null;
    let scrollPositionR = null;
    if (menuReducers && menuReducers.menu) {
        menu = menuReducers.menu;
    }
    // console.log(state)
    if (scrollPositionReducer) {
        scrollPositionR = scrollPositionReducer;
    }

    return {
        status: notify.type,
        error: notify.error,
        message: notify.message,
        variant: notify.variant,
        menu: menu,
        scrollPositionReducer: scrollPositionR,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(oplAppStyle));
const Enhance = enhance(Admin);
export default Enhance;
